exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ColWrap-9b0b033b{display:flex;max-width:1120px;margin:40px auto;padding:0 40px}.MainCol-4634788f{flex:1 1 auto;min-width:0px;margin-right:40px}.SecondaryCol-8cbab189{width:280px;flex:0 0 auto}@media screen and (max-width: 1025px){.ColWrap-9b0b033b{display:block}.MainCol-4634788f{margin-right:0}.SecondaryCol-8cbab189{width:auto}}@media screen and (max-width: 530px){.ColWrap-9b0b033b{margin:20px auto;padding:0 10px}}\n", ""]);

// Exports
exports.locals = {
	"ColWrap": "ColWrap-9b0b033b",
	"MainCol": "MainCol-4634788f",
	"SecondaryCol": "SecondaryCol-8cbab189"
};